import { SplitFulfillmentOrder, SplitOrderItem, SplitOrdersGroup } from './types'

const parseQuantity = (value: unknown): number | undefined => {
  if (value === null || value === undefined || value === '') {
    return undefined
  }

  const numericValue = Number(value)

  if (Number.isNaN(numericValue)) {
    return undefined
  }

  return numericValue
}

const normalizeItem = (item: any): SplitOrderItem => {
  const allocatedQuantity = parseQuantity(item?.allocatedQuantity)
  const quantity = parseQuantity(item?.quantity)
  const requestedQuantity = parseQuantity(item?.requestedQuantity)

  return {
    id: item?.groupLineId ?? item?.orderItemId ?? item?.id,
    groupLineId: item?.groupLineId ?? item?.id,
    orderItemId: item?.orderItemId ?? item?.id,
    productVariantId: item?.productVariantId,
    sku: item?.sku,
    name: item?.name ?? item?.description,
    description: item?.description,
    quantity: quantity ?? requestedQuantity,
    requestedQuantity,
    allocatedQuantity: allocatedQuantity ?? quantity ?? requestedQuantity,
    disposition: item?.disposition,
  }
}

const normalizeOrder = (order: any): SplitFulfillmentOrder => {
  const orderId = Number(order?.orderId ?? order?.id ?? 0)
  const role = order?.fulfillmentRole ?? (order?.isCanonical ? 'CANONICAL' : undefined)

  return {
    id: orderId,
    orderId,
    isCanonical: order?.isCanonical ?? role === 'CANONICAL',
    fulfillmentRole: role,
    fulfillmentSequence: order?.fulfillmentSequence,
    statusLabel: order?.statusLabel,
    statusId: order?.statusId ?? order?.status,
    warehouseName: order?.warehouseName,
    items: Array.isArray(order?.items) ? order.items.map(normalizeItem) : [],
  }
}

export const normalizeFulfillmentGroup = (payload: any): SplitOrdersGroup | null => {
  if (!payload) {
    return null
  }

  const orders: SplitFulfillmentOrder[] = Array.isArray(payload.orders)
    ? payload.orders.map(normalizeOrder)
    : []

  const sortedOrders = [...orders].sort((left, right) => {
    const leftSequence = left.fulfillmentSequence ?? Number.MAX_SAFE_INTEGER
    const rightSequence = right.fulfillmentSequence ?? Number.MAX_SAFE_INTEGER

    if (leftSequence !== rightSequence) {
      return leftSequence - rightSequence
    }

    return Number(left.orderId ?? left.id ?? 0) - Number(right.orderId ?? right.id ?? 0)
  })

  return {
    referenceCode: payload.referenceCode,
    policyName: payload.policyName,
    policySummary: payload.policySummary,
    primarySiteName: payload.primarySiteName,
    orders: sortedOrders,
  }
}

export const normalizeFulfillmentGroupResponse = (response: any): SplitOrdersGroup | null => {
  if (!response) {
    return null
  }

  if (response.fulfillmentGroup) {
    return normalizeFulfillmentGroup(response.fulfillmentGroup)
  }

  return normalizeFulfillmentGroup(response)
}
